import { render, staticRenderFns } from "./HomeMemoryAlgo.vue?vue&type=template&id=18f30c92&scoped=true"
import script from "./HomeMemoryAlgo.vue?vue&type=script&lang=js"
export * from "./HomeMemoryAlgo.vue?vue&type=script&lang=js"
import style0 from "./HomeMemoryAlgo.vue?vue&type=style&index=0&id=18f30c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f30c92",
  null
  
)

export default component.exports